<template>
  <div class="box">
    <div class="left-box" style="flex:1">
      <div class="head-box">
        <div class="box-left-header" style="width: 100%;">
          <div @click="$router.go(-1)" class="goBack c-position-static c-m-0">
            <i class="el-icon-arrow-left"></i>
            <span>质保</span>
            <i class="el-icon-s-cooperation"></i>
          </div>
        </div>
      </div>
      <div class="left-content">
        <el-aside class="message-list-wrapper">
          <el-card class="box-card" shadow="hover">
            <div slot="header" class="clearfix">
              <span>档案信息</span>
              <el-button
                style="float: right; padding: 3px 0"
                type="text"
                @click="edit"
                v-if="osg.has('Warranty,edit')"
              >
                编辑
              </el-button>
            </div>
            <div v-for="(o, index) in messageList" :key="index">
              <template v-if="o.showList && o.showList.indexOf('2') != -1">
                <template v-if="o.name != 'docId'">
                  <span>{{ o.nameDisp ? o.nameDisp : o.name }}</span>
                  <span>{{ '：' + o.showValue }}</span>
                  <el-divider></el-divider>
                </template>
              </template>
            </div>
          </el-card>
        </el-aside>
      </div>
    </div>
    <div class="right-box" style="flex:1">
      <!-- <div class="head-box">
        <h4>保单PDF列表</h4>
      </div> -->
      <div class="content-box">
        <!-- <div class="content-table"> -->
        <el-tabs v-model="activeName" style="margin-top:10px">
          <div style="margin: 10px;padding: 10px 0;">
            <i class="el-icon-info" style="margin-right:3px"></i>
            <span style="font-size: 12px;">
              倒序排列，最新展示在顶部，不同浏览器打开pdf文件，字体显示不同，需要下载到本地才可以查看正常字体
            </span>
          </div>
          <el-tab-pane label="保单PDF列表" name="1">
            <el-table ref="table" :data="pdfList" empty-text="PDF列表为空">
              <el-table-column prop="index" label="序号" width="100"></el-table-column>
              <el-table-column label="PDF地址" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-link
                    :href="
                      'https://www.fsgo365.cn/fsgo/i/pdf.html?file=' +
                        encodeURIComponent(downloadUrl + scope.row.url)
                    "
                    target="_blank"
                  >
                    {{ downloadUrl + scope.row.url }}
                  </el-link>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="出险质保PDF列表" name="2">
            <el-table ref="table" :data="accidentWarrantyPdfList" empty-text="PDF列表为空">
              <el-table-column prop="index" label="序号" width="100"></el-table-column>
              <el-table-column label="PDF地址" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-link
                    :href="
                      'https://www.fsgo365.cn/fsgo/i/pdf.html?file=' +
                        encodeURIComponent(downloadUrl + scope.row.url)
                    "
                    target="_blank"
                  >
                    {{ downloadUrl + scope.row.url }}
                  </el-link>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
        <!-- </div>  -->
      </div>
    </div>

    <el-dialog title="保单信息" :visible.sync="messageDialog" width="800px">
      <c-form
        :formData="warrantyData"
        :fields="messageList"
        :options="options"
        :requestOptions="requestOptions"
        ref="form"
        :upload="upload"
        labelWidth="110px"
        :area="area"
        @changeForm="osg.changeForm"
      ></c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave()">确 定</el-button>
        <el-button @click="messageDialog = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'orgUser',
  data() {
    return {
      collapse: false,
      tenantID: '', //租户id
      options: {},
      searchValue: '', //搜索关键词
      fpi: {
        data: []
      },
      activeName: '1',
      messageList: [], //报单信息列表，包含中文key和value
      queryData: {}, //地址栏的参数
      messageDialog: false, //编辑质保信息弹窗状态
      warrantyData: {}, //质保信息
      pdfList: [], //pdf地址列表
      accidentWarrantyPdfList: [], //出险质保PDF列表
      // 参照options
      requestOptions: {},
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      downloadUrl: this.osg.downloadUrl //七牛下载地址
    };
  },
  mounted() {
    window.$this = this;
    // this.tenantID = JSON.parse(sessionStorage["entity"]).entityID;
    this.queryData = {
      warrantyId: this.osg.param('warrantyId'),
      extId: this.osg.param('id')
    };
    this.osg.codeoption(() => {
      this.getData();
    });
  },
  methods: {
    getData() {
      return new Promise(resolve => {
        var params = {
          // extId: this.queryData.extId,
          colName: 'warranty',
          _all: '1',
          'in:state|array-integer#and': '1',
          sortField: 'order,createTime'
        };
        this.osg.ajax(
          'biz/extField/query.do',
          params,
          res => {
            this.getDataValue(res.data).then(list => {
              this.messageList = this.$util.deepCopy(list).sort((n1, n2) => n1.order - n2.order);
              console.log(this.messageList, '----this.messageList');
              this.getPdfData(this.warrantyData.docId);
            });
          },
          { noload: true }
        );
      });
    },
    //详情查询的是ext，没有value需要查询质保分页列表中的值填充
    getDataValue(list) {
      return new Promise(resolve => {
        var params = {
          page: this.fpi.page,
          rows: this.fpi.rows,
          'is:_id|string#and': this.queryData.warrantyId,
          sortField: 'createTime',
          sortOrder: 'desc'
        };
        this.osg.ajax('document/queryWarranty.do', params, res => {
          if (res.data && res.data.length == 1) {
            this.warrantyData = res.data[0];
            console.log(this.warrantyData, ' -----this.warrantyData');
            resolve(
              list.map(item => {
                for (let key in this.warrantyData) {
                  if (key == item.name) {
                    item.showValue = this.warrantyData[key];
                    return item;
                  }
                }
                return item;
              })
            );
          }
        });
      });
    },
    getPdfData(_id) {
      return new Promise(resolve => {
        this.osg.ajax(
          'document/queryById.do',
          {
            id: _id
          },
          res => {
            if ((res.fileids, res.fileids.length)) {
              //倒序展示，最新在最上面
              res.fileids.reverse();
              this.pdfList = res.fileids.map((item, index) => {
                let items = {
                  index: index + 1,
                  url: item
                };
                return items;
              });
              if (res.exts && res.exts.accidentWarrantyPdfList.length) {
                res.exts.accidentWarrantyPdfList.reverse();
                this.accidentWarrantyPdfList = res.exts.accidentWarrantyPdfList.map(
                  (item, index) => {
                    let items = {
                      index: index + 1,
                      url: item
                    };
                    return items;
                  }
                );
              }
            }
            resolve();
          },
          { noload: true }
        );
      });
    },
    edit() {
      this.messageDialog = true;
    },
    doInit() {
      this.messageDialog = false;
    },
    doSave(pass) {
      if (this.osg.isRepeatClick('saveRecord', 5000)) {
        return;
      }
      if (this.osg.validate() || pass) {
        if (this.osg.isRepeatClick('doSA', 5000)) {
          return;
        }
        var params = this.warrantyData;
        params.area = params.area || [];
        if (params.area.length > 0) {
          params.province = params.area[0] || '';
          if (params.area.length > 1) {
            params.city = params.area[1] || '';
            if (params.area.length > 2) {
              params.district = params.area[2] || '';
              if (params.area.length > 3) {
                params.subdistrict = params.area[3] || '';
              }
            }
          }
        }

        // 关联动态表单创建的工单需要在exts存bizType
        this.messageList.map(item => {
          if (item.frontEndConfig.setField) {
            if (item.frontEndConfig.setField.indexOf('.') != -1) {
              let key1 = item.frontEndConfig.setField.split('.')[0];
              let key2 = item.frontEndConfig.setField.split('.')[1];
              params[key1] = params[key1] || {};
              params[key1][key2] = item.frontEndConfig.setFieldValue;
            } else {
              let key = item.frontEndConfig.setField;
              params[key] = item.frontEndConfig.setFieldValue;
            }
          }
        });

        // 自定义字段转换值
        this.$util.saveFormatExtField(this.messageList, params);
        this.osg.ajax('document/upsertWarranty.do', { warranty: JSON.stringify(params) }, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    //页码变更
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getUsers();
    },
    //当前页变更
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getUsers();
    }
  }
};
</script>
<style scoped>
.filter {
  box-sizing: border-box;
  margin-top: 10px;
  margin-bottom: 8px;
  padding: 0 6px;
}
.message-list-wrapper {
  padding: 10px 20px;
  box-sizing: border-box;
  height: 100%;
  overflow: hidden;
  padding-bottom: 30px;
  box-sizing: border-box;
}
.message-list-card {
  overflow-y: auto;
  height: 100%;
}
>>> .el-card__body {
  overflow-y: auto;
  height: calc(100% - 60px);
}
.box-card {
  height: 100%;
}
</style>
